import { FC } from 'react';
import i18n from 'i18n';
import DefaultLayout from 'components/Rsuite/Layout/DefaultLayout';
import RtbCampaignSelectAdType from './RtbCampaignSelectAdType';
import { useOrderStore } from 'store/orderStore';
import { RsBreadCrumb } from 'components/Rsuite/BreadCrumb';

// const webService: OrderWebService = new RestfulOrderWebService();

const RtbCampaignSelectAdTypePage: FC = () => {
  const { order } = useOrderStore();

  return (
    <DefaultLayout
      title={'新增廣告活動'}
      breadcrumb={
        <RsBreadCrumb
          data={[
            {
              label: i18n.t<string>('orderHome.labels.title'),
              href: '/orders',
            },
            {
              label: order?.projectName,
              href: `/orders/${order?.orderNumber}`,
            },
            {
              label: '新增廣告活動',
              active: true,
            },
          ]}
        />
      }
    >
      <RtbCampaignSelectAdType />
    </DefaultLayout>
  );
};

export default RtbCampaignSelectAdTypePage;
